import { render, staticRenderFns } from "./TesoreriaMovements.vue?vue&type=template&id=56f9e02e&"
import script from "./TesoreriaMovements.vue?vue&type=script&lang=js&"
export * from "./TesoreriaMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports